import Vue from "vue";
import App from "./App.vue";
//import i18n from "@/plugins/i18n";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueCompositionAPI from "@vue/composition-api";
import "@/assets/styles/styles.css";
import Swal from "sweetalert2";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { VueMaskDirective } from "v-mask";
Vue.directive("mask", VueMaskDirective);
const firebaseConfig = {
  apiKey: "AIzaSyDhynW3Vq3wGbjKVENzHe5UmEMCQEfIkgk",
  authDomain: "solupag-406517.firebaseapp.com",
  projectId: "solupag-406517",
  storageBucket: "solupag-406517.appspot.com",
  messagingSenderId: "812176480417",
  appId: "1:812176480417:web:ca0a88b45aabcb3a4f78e0",
  measurementId: "G-DB8HEVD19B",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

Vue.use(VueCompositionAPI, Swal);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  // i18n,
  render: (h) => h(App),
}).$mount("#app");
